import configureStore from './configureStore';

import { loadState, saveState } from './persist';
import config from '../../config/app';



const initialState = loadState();
const store = configureStore(initialState);


store.subscribe(() => {
	// persist your state
	saveState(store.getState())
})

store.dispatch({
	type: 'SET_STORE_VERSION',
	payload: config.store_version
})


export default store;



// WEBPACK FOOTER //
// ./src/store/store.js